import { maLookback } from '../../math/ma'
import { COLOR, histogram, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MACDEXT',
  version: 1,
  label: 'MACD (custom MA types)',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 200,
  inputs: [
    period('fastperiod', 12, 'Fast length'),
    matype('fastmatype', 0, 'Fast MA type'),
    period('slowperiod', 26, 'Slow length'),
    matype('slowmatype', 0, 'Slow MA type'),
    period('signalperiod', 9, 'Signal length'),
    matype('signalmatype', 0, 'Signal MA type'),
  ],
  outputs: [line('macd', 'MACD', COLOR.blue), line('signal', 'Signal', COLOR.orange), histogram('hist', 'Histogram', COLOR.green, COLOR.red)],
  talib: {
    functions: ['MACDEXT'],
    expr: 'MACDEXT(close, fastperiod={fastperiod}, fastmatype={fastmatype}, slowperiod={slowperiod}, slowmatype={slowmatype}, signalperiod={signalperiod}, signalmatype={signalmatype})',
    outputs: { macd: 'macd', signal: 'macdsignal', hist: 'macdhist' },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, fastmatype, slowperiod, slowmatype, signalperiod, signalmatype }) =>
    Math.max(maLookback(fastperiod, fastmatype), maLookback(slowperiod, slowmatype)) + maLookback(signalperiod, signalmatype),
}
export default def
